import { cardRef, defineGameCard, onAppear } from '../authoring/index.js';
import { alliedPlants, healUnit, isLiveOnBoard, tableOf } from './plant-helpers.js';
/**
 * Лист — дешёвое тело для Кроны. При ПОЯВЛЕНИИ (розыгрыш ИЛИ создание токеном —
 * Великий баньян, Папоротник и т.п., D53+) лечит на 1 наиболее повреждённое
 * другое союзное Растение этой локации; при равенстве берётся первое в каноническом
 * порядке.
 */
export const PlantLeafCard = defineGameCard({
    id: 'plant_leaf',
    gameplay: {
        type: 'UNIT',
        cost: 1,
        baseStats: { attack: 0, health: 1 },
        traits: ['PLANT', 'LEAF'],
    },
    presentation: {
        name: 'Лист',
        description: 'При появлении наиболее повреждённое другое ваше Растение в этой локации восстанавливает 1 здоровье. Крона саженца может пожертвовать этим Листом, чтобы он принял весь урон одной атаки.',
        glyph: {
            colors: ['#10213A', '#5B9A3B', '#75AE42', '#41892E', '#41892E'],
            rows: [
                '....................',
                '....................',
                '............11111...',
                '..........11233331..',
                '........1133233331..',
                '.......12323322331..',
                '......133233323321..',
                '.....1233323433341..',
                '.....1232234333241..',
                '....12323343233341..',
                '....1233243332341...',
                '....1323432322341...',
                '....123433223341....',
                '....12422224441.....',
                '....1244444441......',
                '...1411111111.......',
                '..141...............',
                '...1................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('plant_leaf')],
    abilities: [
        // Появление (D53+): срабатывает и для Листа, сыгранного из руки, и для Листа,
        // созданного токеном другим Растением — больше никакой ручной фильтрации по isToken.
        onAppear((ctx) => {
            const self = ctx.self;
            if (!isLiveOnBoard(self))
                return;
            const plants = alliedPlants(ctx, self.controllerId, {
                tableId: tableOf(self.cellId),
                exclude: new Set([self.id]),
            });
            let best;
            for (const plant of plants) {
                const stats = ctx.q.stats(plant.id);
                const damage = stats.maxHealth - stats.health;
                if (damage > 0 && (best === undefined || damage > best.damage)) {
                    best = { id: plant.id, damage };
                }
            }
            if (best !== undefined)
                healUnit(ctx, best.id, 1, self.id);
        }),
    ],
    ui: { mechanics: ['crown'] },
});
//# sourceMappingURL=plant_leaf.js.map